import React from 'react';
import { Flex, Row, Col, Skeleton, Button, Divider, Card, Tag, Badge } from 'antd';
import { HomeOutlined, ShoppingOutlined, ShopOutlined, TeamOutlined, ApiOutlined, ScanOutlined, ShareAltOutlined,
  BarChartOutlined, SolutionOutlined, GiftOutlined, PartitionOutlined, ShoppingCartOutlined, FileImageOutlined,
  PlusOutlined, EditOutlined, MobileOutlined, CheckCircleOutlined
} from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import Can from '../../components/ability';
import { sendUserLoginToApp, SafeStorage, detectWebView } from '../../utils/jsbridge';
import TopSeller from '../chart/topSeller';
import { openWxminiShop } from '../shop/tools';

const { isWebView } = detectWebView();

const iconStyle = {
  fontSize: 28,
}

const Index = () => {
  const [loading, setLoading] = React.useState(true);
  const [hasAbility, setHasAbility] = React.useState(false);

  const toMiniShop = async () => {
    const { accId, shopId } = (await getMyShops()).filter(item => item.isHead)?.[0] || {};
    if(accId && shopId) await openWxminiShop(accId, shopId);
  }

  const shortcuts = [
    {
      id: 1,
      title: '发布商品',
      description: '快速发布新商品',
      href: '/goods/create',
      icon: <PlusOutlined />,
      color: '#1890ff'
    },
    {
      id: 2,
      title: '小程序装修',
      description: '美化店铺页面',
      href: '/mall',
      icon: <EditOutlined />,
      color: '#52c41a'
    },
    {
      id: 3,
      title: '查看小程序',
      description: '预览小程序店铺',
      onClick: toMiniShop,
      icon: <MobileOutlined />,
      color: '#faad14'
    }
  ];

  React.useEffect(() => {
    const checkUserAbility = async () => {
      try {
        let userAbility = await SafeStorage.getItem('user-ability', true);
        if (userAbility) {
          setHasAbility(true);
        }
      } catch (e) {
        console.error('Failed to get user ability:', e);
      } finally {
        setLoading(false);
      }
    };

    checkUserAbility();
  }, []);

  React.useEffect(() => {
    // 获取设备信息
    sendUserLoginToApp({
        userId: window.__baseInfo.userId,
    });
  })

  // 检测是否在PWA模式下运行
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone ||
                       document.referrer.includes('android-app://');
  
  // 检测是否为iOS设备
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                /Macintosh/.test(navigator.userAgent);

  if (loading) {
    return <Skeleton active />;
  }

  if (!hasAbility) {
    return <div>暂无权限</div>;
  }

  const getMyShops = async () => {
    let response = await fetch(`/api/shop/my-permission-list`);
    let result = await response.json();

    if(result && result.success) {
        return result.data;
    }

    return [];
  }

  return (
    <div>
      {/* <div style={{ height: '200px'}}><TopSeller /></div> */}
      {/* <PWAInstall /> */}
      <a 
        onClick={toMiniShop}
        style={{ 
          height: '80px', width: '100%', display: 'block',
          background: 'url("https://img.yxdj.tech/yxdj-system/example/banner.png") no-repeat left center',
          margin: '0 0 20px 0', lineHeight: '80px', textAlign: 'center', fontSize: '30px', color: '#ffffff',
          borderRadius: '6px',
        }}
      ></a>

      <Row gap={20} style={{ margin: '10px 0 0 0' }}>
        <Can action="read" subject="shop">
          <NavItem href="/shop" text="店铺管理">
            <HomeOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="order">
          <NavItem href="/order" text="订单管理">
            <ShoppingCartOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="goods">
          <NavItem href="/goods" text="商品管理">
            <ShoppingOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="mall">
          <NavItem href="/mall" text="小程序装修">
            <ShopOutlined style={iconStyle} />
          </NavItem>
        </Can>


      </Row>
      <Divider style={{ marginTop: '14px' }} />
      <Row gap={20}>

        <Can action="read" subject="customer">
          <NavItem href="/customer" text="客户管理">
            <SolutionOutlined style={iconStyle} />
          </NavItem>
        </Can>
        

        <Can action="read" subject="shop">
          <NavItem href="/salesnet" text="联盟">
            <PartitionOutlined style={iconStyle} />
          </NavItem>
        </Can>
        

        <Can action="read" subject="promotion">
          <NavItem href="/promotion" text="营销管理">
            <GiftOutlined style={iconStyle} />
          </NavItem>
        </Can>
        
        {window.__baseInfo.versionId !== 1 && <Can action="read" subject="channel">
          <NavItem href="/channel" text="经营渠道">
            <ApiOutlined style={iconStyle} />
          </NavItem>
        </Can>}

        <Can action="read" subject="account">
          <NavItem href="/account" text="账号管理">
            <TeamOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="finance">
          <NavItem href="/finance" text="财务对账">
            <BarChartOutlined style={iconStyle} />
          </NavItem>
        </Can>

        {window.__baseInfo.versionId !== 1 && <Can action="read" subject="mall">
          <NavItem href="/album" text="素材中心">
            <FileImageOutlined style={iconStyle} />
          </NavItem>
        </Can>}

        <Can action="read" subject="order">
          <NavItem href="/writeoff" text="核销">
            <ScanOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="order">
          <NavItem href="/join" text="邀请(获得佣金)">
            <ShareAltOutlined style={iconStyle} />
          </NavItem>
        </Can>
      </Row>
      
      {/* APP 下载按钮，仅在非 WebView、非 PWA 且非 iOS 环境下显示 */}
      {!isWebView && !isStandalone && !isIOS && (
        <div style={{
          position: 'fixed',
          bottom: '100px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '80%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <Button 
            type="primary" 
            size="large"
            href='https://img.yxdj.tech/yxdj-system/app/latest.apk'
            style={{ 
              height: '50px', 
              fontSize: '16px', 
              fontWeight: 'bold',
              backgroundColor: '#1890ff',
              borderColor: '#1890ff'
            }}
          >
            下载优选到家 APP（更多功能）
          </Button>
        </div>
      )}

      {/* 常用快捷方式 - 放在页面底部 */}
      <Card 
        style={{ marginTop: '20px', marginBottom: isWebView || isStandalone || isIOS ? '20px' : '120px' }}
        title={
          <Flex align="center" justify="space-between">
            <span>快捷入口</span>
          </Flex>
        }
      >
        <Row gutter={[16, 16]}>
          {shortcuts.map(shortcut => (
            <Col xs={24} sm={8} key={shortcut.id} style={{ marginBottom: '0' }}>
              <Card
                hoverable
                size="small"
                onClick={() => shortcut.onClick ? shortcut.onClick() : (shortcut.href && (window.location.href = shortcut.href))}
                style={{ 
                  borderLeft: `4px solid ${shortcut.color}`,
                  cursor: 'pointer',
                  height: '100%'
                }}
              >
                <Flex align="center" gap={12}>
                  <div style={{ 
                    fontSize: '24px', 
                    color: shortcut.color,
                    flexShrink: 0
                  }}>
                    {shortcut.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: '16px', 
                      fontWeight: 'bold',
                      marginBottom: '4px'
                    }}>
                      {shortcut.title}
                    </div>
                    <div style={{ 
                      fontSize: '13px', 
                      color: '#666'
                    }}>
                      {shortcut.description}
                    </div>
                  </div>
                </Flex>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  )
}

export default Index;